import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("abs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url.includes("/auth/")) {
      original._retry = true;
      try {
        const { data } = await api.post("/auth/refresh");
        localStorage.setItem("abs_token", data.token);
        return api(original);
      } catch {
        localStorage.removeItem("abs_token");
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
}

export const CATEGORIES = [
  { id: "all", label: "All" },
  { id: "apparel", label: "Apparel" },
  { id: "hats", label: "Hats & Caps" },
  { id: "bands", label: "Wrist & Headbands" },
  { id: "bottles", label: "Bottles" },
  { id: "gear", label: "Gear" },
  { id: "programs", label: "Training Programs" },
  { id: "supplements", label: "Supplements" },
  { id: "meals", label: "Meal Plans" },
];

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;
